import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

import { AuthService } from '../services/auth.service';

/**
 * Guards the login page: a user who can already enter the app has no business there and is sent to
 * the dashboard.
 *
 * The decision is AuthService.canEnterApp, the predicate AuthGuard applies on the other side. With
 * two different rules a user could be refused by both pages at once or bounce between them; the
 * former redirect target `/home` did not exist as a route (#26615).
 */
@Injectable({ providedIn: 'root' })
export class NoAuthGuard implements CanActivate {
  path: ActivatedRouteSnapshot[];
  route: ActivatedRouteSnapshot;

  constructor(
    private _authService: AuthService,
    private _router: Router
  ) {}

  async canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    await this._authService.init;

    if (!this._authService.canEnterApp) {
      return true;
    }

    await this._router.navigate(['/dashboard']);

    return false;
  }
}
